export function requireEnv(name: string): string {
  const value = import.meta.env[name] as string | undefined
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`)
  }
  return value
}
